import FormControlLabel from "@material-ui/core/FormControlLabel"
import Switch, { SwitchProps } from "@material-ui/core/Switch"
import React from "react"

interface SwitchButtonProps extends SwitchProps {
  isChecked: boolean
  onChange?: (
    event: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) => void

  title: string
  disabled?: boolean
}
export default function SwitchButton({
  isChecked,
  onChange,
  title,
  disabled = false,
  ...props
}: SwitchButtonProps) {
  // const { isChecked, onChange, title, disabled = false } = props

  return (
    <FormControlLabel
      control={
        <Switch
          checked={isChecked}
          onChange={onChange}
          color="primary"
          name={title}
          {...props}
        />
      }
      disabled={disabled}
      label={title}
    />
  )
}
